<template>
	<ButtonLayout class="icon-button-layout">
		<slot :icon-class="`icon-button-layout__icon`"></slot>
	</ButtonLayout>
</template>

<script>
import ButtonLayout from "./ButtonLayout.vue";

/**
 * Enforces icon button layout in terms of color, size, padding, and margins.
 * Designed to be extended for specialized cases.
 */
export default {
	name: "IconButtonLayout",
	components: {
		ButtonLayout,
	},
};
</script>

<style lang="scss" scoped>
.icon-button-layout.size--md {
	height: 2.5rem; // 40px
	width: 2.5rem; // 40px
	@include font-and-line-for(1);
}

.icon-button-layout.size--sm {
	height: 2rem; // 32px
	width: 2rem; // 32px
	@include font-and-line-for(0);
}

.icon-button-layout.size--xs {
	height: 1.5rem; // 24px
	width: 1.5rem; // 24px
	@include font-and-line-for(-1);
}
</style>
